










import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import moment from 'moment';

interface DateInfo {
  updated: string;
  created: string;
  updatedBy: string;
}

@Component
export default class UiUpdateInfo extends Vue {
  @Prop({ default: {} })
  data: object;

  @Prop({ default: '' })
  infoFormat: string;

  get updateInfo() {
    const { updated, created, updatedBy } = this.data as DateInfo;
    const timestamp = `${updated || created} (UTC)`;

    if (this.infoFormat === 'short') {
      return this.t('<b>Last Updated</b>{0}', [`&nbsp;<span>${timestamp}</span>`])
    }

    if (updatedBy === 'Team Member') {
      return this.t('Updated by Team Member, {0}', [timestamp])
    }

    const name = updatedBy || this.t('No Name');

    return this.t('<b>Last Updated:</b> {0} <span>{1}</span>', [`&nbsp;<span class="name">${name}</span>`, timestamp])
  }
}
